import axios from "axios";
import { toast } from "react-toastify";

import { API_BASE } from "./constants";

const authHeader = () => {
  const token = localStorage.getItem("wdtoken");
  if (token) {
    return { Authorization: "Bearer " + token };
  }
  return {};
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (history = null) => {
  const axiosInstance = axios.create({ baseURL: API_BASE, headers: authHeader() });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      
      if (
        error.response.status === 401 || 
        (error.response.data?.error === "Please authenticate")
      ) {
        const { error: message } = error.response.data;
      
        localStorage.clear();
      
        if (message === "Please authenticate") {
          toast.error(message, { toastId: "errorIf" });
        } else {
          // toast.error("Logging Out!!", { toastId: "errorElse" });
        }
      
        setTimeout(() => {
          localStorage.clear();
          if (history) {
            history.push("/login");
          } else {
            window.location = "/login";
          }
        }, 1000);
      }
      
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
